import { css } from '@linaria/core';
import { useJSONModal } from 'modules/Predictions/components/PredictionSidebar/useUploadModal';
import { Button } from 'components/ui_library/Button';
import { CopyButton } from 'components/CopyButton';
import { CollapsibleBar, CollapsibleBarProps } from '../CollapsibleBar/CollapsibleBar';
import { hasText } from '../utils';
export interface OcrOutput {
  [regionId: string]: string;
}
interface TextTranslationViewProps {
  model: CF.API.Models.Model;
  modelOutput: CF.API.ModelOutputs.ModelOutput;
  collapsibleBarProps: Omit<CollapsibleBarProps, 'children' | 'isThresholdSliderVisible'>;
}
export const TextTranslationView = ({
  model,
  modelOutput,
  collapsibleBarProps
}: TextTranslationViewProps): JSX.Element => {
  const {
    data
  } = modelOutput;
  const openJsonModal = useJSONModal({
    json: modelOutput
  }, 'model_page');
  return <CollapsibleBar modelId={model.id} isThresholdSliderVisible={false} {...collapsibleBarProps}>
      {hasText(data) && <div className={imageToText}>
          <div className="translation-output-text">
            <div className={copyBtnWrapper}>
              <CopyButton text={data.text.raw} />
            </div>
            {data.text.raw}
          </div>
        </div>}
      <Button variant="secondary" size="sm" onClick={openJsonModal}>
        View JSON
      </Button>
    </CollapsibleBar>;
};
const imageToText = "omponents__ModelOutputRenderer__components__ModelOutputTypeViews__TextTranslationView_tsx-imageToText-i1flo7sw";
const copyBtnWrapper = "omponents__ModelOutputRenderer__components__ModelOutputTypeViews__TextTranslationView_tsx-copyBtnWrapper-c1g368k9";

require("./TextTranslationView.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./TextTranslationView.tsx");